import { useEffect } from "react";

declare global {
  interface Window {
    zE?: (action: string, ...args: any[]) => void;
    zESettings?: any;
  }
}

interface ZendeskChatProps {
  candidateZendeskJwt?: string;
  candidateName?: string;
  candidateEmail?: string;
}

const ZendeskChat = ({
  candidateZendeskJwt,
  candidateName,
  candidateEmail,
}: ZendeskChatProps) => {
  useEffect(() => {
    window.zESettings = {
      webWidget: {
        launcher: {
          label: {
            "*": "Aide CIFMD",
          },
        },
        position: {
          horizontal: "right",
          vertical: "top",
        },
        offset: {
          vertical: "5px",
          horizontal: "260px",
        },
        authenticate: {
          chat: {
            jwtFn: (callback: (jwt: string) => void) => {
              if (candidateZendeskJwt) {
                callback(candidateZendeskJwt);
              }
            },
          },
        },
      },
    };

    const script = document.createElement("script");
    script.src = `https://static.zdassets.com/ekr/snippet.js?key=${
      import.meta.env.VITE_ZENDESK_KEY
    }`;
    script.async = true;
    script.id = "ze-snippet";

    document.body.appendChild(script);

    if (window.zE && (candidateName || candidateEmail))
      window.zE("webWidget", "prefill", {
        name: candidateName
          ? {
              value: candidateName,
              readonly: true,
            }
          : undefined,
        email: candidateEmail
          ? {
              value: candidateEmail,
              readonly: true,
            }
          : undefined,
      });

    return () => {
      const scriptToRemove = document.getElementById("ze-snippet");
      if (scriptToRemove && scriptToRemove === script) {
        document.body.removeChild(scriptToRemove);
      }
    };
  }, [candidateName, candidateEmail, candidateZendeskJwt]);

  return null;
};

export default ZendeskChat;
